import React, { Component, useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import desktopBackground from "../../assets/images/desktopBackground.png";
import logo from "../../assets/images/logo-default.svg";
import logoCompany from "../../assets/images/logo-company.svg";
import fingerprint from "../../assets/images/icon_login/fingerprint.svg";
import bsi from "../../assets/images/bsi.png";
import * as API from "../../core/service/api.js";
import {} from "../../core/feature/store";
import eye from "../../assets/images/icon_login/eye.svg";
import eyeOff from "../../assets/images/icon_login/eye-off.svg";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import {
  removeCompany,
  setCompany,
} from "../../core/feature/company/companySlice";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createPassword, updatePassword } from "../../core/service/api_profile";
import { useDispatch } from "react-redux";
import { setLoading } from "../../core/feature/config/configSlice";
import User from "../../core/models/user";

const CreatePasswordMobile = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const location: any = useLocation();
  const style = "min-h-screen h-full font-montserrat p-10 bg-psp-primary";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [inputActive, setInputActive] = useState(true);
  const [matchStatusPassword, setMatchStatusPassword] = useState("0");

  const [typeOldPassword, setTypeOldPassword] = useState("password");
  const [typeNewPassword, setTypeNewPassword] = useState("password");
  const [typeNew2Password, setTypeNew2Password] = useState("password");
  const user: User = useAppSelector((state) => state.user.user);
  const [data, setData] = useState<any>({});
  const updatePass = async () => {
    if (oldPassword == "")
      return toast.warning(t("CHANGE-PASSWORD.errorOldPass"));
    if (newPassword == "" || newPassword2 == "")
      return toast.warning(t("CHANGE-PASSWORD.errorNewPass"));
    if (newPassword != newPassword2)
      return toast.warning(t("CHANGE-PASSWORD.errorNotMatch"));

    const regexPassword = /^(?=.*[a-z])(?=.*\d)[a-zA-Z\d]{6,}$/;

    if (!newPassword.match(regexPassword) || !newPassword2.match(regexPassword))
      return toast.warning(t("LOGIN.passContain"));

    dispatch(setLoading(true));
    var query = {
      oldPassword: oldPassword,
      newPassword: newPassword,
    };

    updatePassword(query)
      .then((res) => {
        dispatch(setLoading(false));
        toast.success(t("CHANGE-PASSWORD.success"));
        setOldPassword("");
        setNewPassword("");
        setNewPassword2("");
        setInputActive(true);
        navigate("/home", {
          replace: true,
        });
      })
      .catch((err) => {
        dispatch(setLoading(false));
      });
  };
  const funTypePassword = async (type: string) => {
    switch (type) {
      case "old":
        if (typeOldPassword == "text") {
          setTypeOldPassword("password");
        } else {
          setTypeOldPassword("text");
        }
        break;
      case "new":
        if (typeNewPassword == "text") {
          setTypeNewPassword("password");
        } else {
          setTypeNewPassword("text");
        }
        break;
      default:
        if (typeNew2Password == "text") {
          setTypeNew2Password("password");
        } else {
          setTypeNew2Password("text");
        }
        break;
    }
  };

  const checkMatchPassword = useMemo(() => {
    if (newPassword != newPassword2) {
      setMatchStatusPassword("1");
    } else if (newPassword == "") {
      setMatchStatusPassword("0");
    } else {
      setMatchStatusPassword("2");
    }
  }, [newPassword, newPassword2]);
  return (
    <>
      <div className={style}>
        <div className="mt-24">
          <img src={logo} className="w-52 mx-auto" />
        </div>

        <div className="px-4 pb-0 pt-6 mt-4 top-to-bottom">
          <h1 className="text-psp-primary m-0 text-xl font-bold">
            {`${t("CREATE-PASSWORD.title")}`}
          </h1>
          <p className=" text-sm font-medium text-[#B9B9B9]">
            {t("CREATE-PASSWORD.subtitle")}
          </p>

          <div className="flex flex-col">
            <div className="mt-2 grow">
              <p className="text-sm font-medium text-[#B9B9B9] m-0 mb-1">
                {t("CREATE-PASSWORD.oldPassword")}
              </p>
              <div className="relative w-full flex">
                <input
                  type={typeOldPassword}
                  onChange={(e) => {
                    setOldPassword(e.target.value);
                  }}
                  className="px-3 w-full rounded-xl h-10 border-1 border-psp-border-gray border-solid"
                />
                <img
                  src={typeOldPassword != "text" ? eyeOff : eye}
                  className="font-bold text-black absolute z-10 top-2 right-5"
                  onClick={() => funTypePassword("old")}
                />
              </div>
            </div>
            <div className="mt-2 grow">
              <p className="text-sm font-medium text-[#B9B9B9] m-0 mb-1">
                {t("CREATE-PASSWORD.password")}
              </p>
              <div className="relative w-full flex">
                <input
                  type={typeNewPassword}
                  onChange={(e) => (
                    setNewPassword(e.target.value), checkMatchPassword
                  )}
                  className="px-3 w-full rounded-xl h-10 border-1 border-psp-border-gray border-solid"
                />
                <img
                  src={typeNewPassword != "text" ? eyeOff : eye}
                  className="font-bold text-black absolute z-10 top-2 right-5"
                  onClick={() => funTypePassword("new")}
                />
              </div>
            </div>
            <div className="mt-2 grow">
              <p className="text-sm font-medium text-[#B9B9B9] m-0 mb-1">
                {t("CREATE-PASSWORD.retypePassword")}
              </p>
              <div className="relative w-full flex">
                <input
                  type={typeNew2Password}
                  onChange={(e) => (
                    setNewPassword2(e.target.value), checkMatchPassword
                  )}
                  className={
                    matchStatusPassword == "2"
                      ? `bg-green-100 px-3 w-full rounded-xl h-10 border-1 border-green-300 border-solid`
                      : matchStatusPassword == "1"
                      ? `bg-red/10 px-3 w-full rounded-xl h-10 border-1 border-red/ border-solid`
                      : `px-3 w-full rounded-xl h-10 border-1 border-red/ border-solid`
                  }
                />
                <img
                  src={typeNew2Password != "text" ? eyeOff : eye}
                  className="font-bold text-black absolute z-10 top-2 right-5"
                  onClick={() => funTypePassword("new2")}
                />
              </div>
            </div>
          </div>

          <div className="mt-4">
            <button
              onClick={() => updatePass()}
              className="mt-2 bg-psp-btn-primary text-white font-bold w-full py-2 rounded-lg hover:text-red-600 hover:ring-2 hover:ring-offset-cyan-600  active:bg-psp-active"
            >
              {t("CREATE-PASSWORD.next")}
            </button>
            <button
              onClick={() => navigate("/login", { replace: true })}
              className="px-4 mt-2 bg-transparent border-[0.5px] border-solid border-[#0054E6] text-[#0054E6] font-bold text-sm items-center justify-center  w-full flex flex-row rounded-lg gap-3 py-2.5 active:bg-psp-active"
            >
              {t("OTHER.back")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreatePasswordMobile;
